import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import BreakoutModuleNarrow from '../../../shared/breakoutModules/BreakoutModuleNarrow'
import WelcomeDeck from './WelcomeDeck'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: [2],
  align: LAYOUT_ALIGN.CENTER,
})``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const OnboardingWelcomePage = ({ content }) => {
  const { deck } = content

  return (
    <BreakoutModuleNarrow
      hasGradient={false}
      hasBottomBorder={false}
      paddingV={[1, 2, [2.25, 3]]}
    >
      <Layout>
        <WelcomeDeck deck={deck} />
      </Layout>
    </BreakoutModuleNarrow>
  )
}

OnboardingWelcomePage.propTypes = {
  content: PropTypes.object.isRequired,
}

export default OnboardingWelcomePage
